import { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { ConversationTurn } from "../MessageList/MessageList";
import "./ConversationHistoryDialog.css";

export default function ConversationHistoryDialog({ aiPartnerLabel, conversation = [], onClose, open }) {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onCloseRef.current();
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="conversation-history-overlay" role="presentation">
      <button
        aria-label="Close conversation history"
        className="conversation-history-backdrop"
        onClick={onClose}
        type="button"
      />
      <section
        aria-labelledby="conversation-history-title"
        aria-modal="true"
        className="conversation-history-dialog"
        role="dialog"
      >
        <div className="conversation-history-handle" aria-hidden="true" />
        <header className="conversation-history-header">
          <h2 id="conversation-history-title">Conversation History</h2>
          <button
            aria-label="Close conversation history"
            className="conversation-history-close"
            onClick={onClose}
            type="button"
          >
            <X size={20} />
          </button>
        </header>

        <div className="conversation-history-content">
          {conversation.length ? (
            conversation.map((turn, index) => (
              <ConversationTurn
                aiPartnerLabel={aiPartnerLabel}
                key={`history-turn-${index}`}
                turn={turn}
              />
            ))
          ) : (
            <p className="conversation-history-empty">
              Your conversation will appear here after the session starts.
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
